import React, { Component } from 'react'
import { Message } from '@paypalcorp/worldready-react'
import Dropzone from 'react-dropzone'
import _ from 'lodash'

import { fileOptionsConstants } from '../constants/fileOptions'
import { constants } from '../constants/constants'
import { shareConstants } from '../constants/shareConstants'
import MoveOrCopy from './MoveOrCopy'
import InputBox from './InputBox'

import {
  dateConverter,
  formatFileSize,
  calculateUserPermission,
  removeExtraSlashes,
  checkNoDataMessageVisibility,
  getKeyByValue,
  getLocalizedContent,
  checkEmailMaskBeforeRender,
} from '../helper'

import { ReactComponent as FolderClose } from '../images/folder-line.svg'
import { ReactComponent as FolderCloseGrey } from '../images/folder-line-grey.svg'

class ListView extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      newFolderName: '',
      dragItem: -1,
      renameValue: '',
      itemOnHover: '',
      renderErrorFor: -1,
      renderErrorType: '',
      selectedOptionList: '',
    }
    this.prevRenderErrorFor = []
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClick, false)
  }

  componentDidUpdate(prevProps) {
    const {
      isCreateFolderInProgress,
      hasFileToRename,
      fileToRename,
      renameIsInProgress,
      showCreateFolder,
    } = this.props

    if (!isCreateFolderInProgress && prevProps.isCreateFolderInProgress) {
      this.setStateValue('newFolderName', '')
    }
    if (!showCreateFolder && prevProps.showCreateFolder) {
      this.setStateValue('newFolderName', '')
    }
    if (
      hasFileToRename &&
      !prevProps.hasFileToRename &&
      this.state.renameValue === ''
    ) {
      this.setStateValue('renameValue', fileToRename.fileName)
    }
    if (
      this.state.renameValue !== '' &&
      !renameIsInProgress &&
      !hasFileToRename &&
      prevProps.hasFileToRename
    ) {
      this.setStateValue('renameValue', '')
    }
  }

  setStateValue = (key, value) => {
    this.setState({ [key]: value })
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClick, false)
  }

  handleClick = (event) => {
    const { showButton } = this.props
    const classList = event.target.classList.value
    const { renderErrorFor, renderErrorType } = this.state
    if (showButton) {
      return
    }
    if (renderErrorFor !== -1 && renderErrorType === 'upload') {
      if (!classList.includes(`${`upload_alert_${renderErrorFor}`}`)) {
        this.removeFilesFromUploadList(renderErrorFor)
      } else if (
        this.prevRenderErrorFor[1] === renderErrorType &&
        this.prevRenderErrorFor[0] !== renderErrorFor
      ) {
        this.removeFilesFromUploadList(this.prevRenderErrorFor[0])
      }
      return
    }
    if (renderErrorFor !== -1 && renderErrorType === '') {
      if (!classList.includes(`${`alert_${renderErrorFor}`}`)) {
        this.removeErrorFromFiles(renderErrorFor)
      } else if (
        this.prevRenderErrorFor[1] === renderErrorType &&
        this.prevRenderErrorFor[0] !== renderErrorFor
      ) {
        this.removeErrorFromFiles(this.prevRenderErrorFor[0])
      }
      return
    }
    if (
      !classList.includes('ppvx_icon-elipsis-vertical') &&
      !classList.includes('list__options') &&
      !classList.includes('moveorcopy')
    ) {
      this.props.fileOptionStatus('', false)
    }
  }

  removeErrorFromFiles = (index) => {
    const { files } = this.props
    if (files.results && files.results[index] && files.results[index].status) {
      delete files.results[index].status
      delete files.results[index].msg
      this.props.actions.setFileDetails(files)
    }
  }

  removeFilesFromUploadList = (index) => {
    const { filesToUpload } = this.props
    let filesUpload = filesToUpload.filter((files, i) => i !== index)
    this.props.actions.setFilesToUpload(filesUpload)
    this.setState({ renderErrorFor: -1, renderErrorType: '' })
    this.prevRenderErrorFor = []
  }

  capture = (evt) => {
    const { newFolderName } = this.state
    if (
      evt.key === 'Enter' ||
      (typeof evt.key === 'undefined' && newFolderName.trim() !== '')
    ) {
      this.props.capture(newFolderName, false)
    } else if (typeof evt.key === 'undefined') {
      this.setState({
        newFolderName: '',
      })
      this.props.capture('', false)
    }
  }

  setNewFolderValue = (evt) => {
    this.setState({ newFolderName: evt.target.value })
  }

  convertDate = (dates) => {
    const date = dates.split(' ')
    return dateConverter(`${date[0]} ${date[1]}`)
  }

  onSortIconClick = (sortType, sortBy) => {
    this.props.actions.setSortBy(sortBy)
    this.props.actions.setSortType(sortType)
    this.props.removeStateValuesOnFileOperation()
    this.props.sortFileList(sortType, sortBy)
  }

  getFolderOptions = (
    fileItem,
    list,
    baseFolder,
    userPermission,
    fileOptionType,
  ) => {
    if (
      list.hasOwnProperty('sharedBy') &&
      baseFolder !== '/' &&
      userPermission === shareConstants.FilePermissions.readWriteExecute
    ) {
      return _.find(fileOptionsConstants.FileOptions[fileOptionType], [
        'type',
        'subFolder',
      ]).options
    }
    return fileItem.options
  }

  getFileOptions = (
    fileItem,
    list,
    baseFolder,
    userPermission,
    fileOptionType,
  ) => {
    if (
      fileItem.type === 'file' &&
      list.hasOwnProperty('sharedBy') &&
      baseFolder === '/'
    ) {
      return _.find(fileOptionsConstants.FileOptions[fileOptionType], [
        'type',
        'sharedFile',
      ]).options
    }
    return fileItem[userPermission]
  }

  checkOptions = (fileItem, userPermission, fileOptionType, list) => {
    const { baseFolder } = this.props
    if (fileOptionType === 'default') {
      return fileItem.options
    } else if (fileOptionType === 'shared') {
      if (fileItem.type === 'folder') {
        return this.getFolderOptions(
          fileItem,
          list,
          baseFolder,
          userPermission,
          fileOptionType,
        )
      }
      return this.getFileOptions(
        fileItem,
        list,
        baseFolder,
        userPermission,
        fileOptionType,
      )
    }
    return fileItem.options
  }

  onOptionsClick = (list, options) => {
    if (options === 'Move to') {
      this.setState({ selectedOptionList: 'Move to' })
    } else if (options === 'Copy to') {
      this.setState({ selectedOptionList: 'Copy to' })
    }
    this.props.onOptionsClick(list, options)
  }

  renderMoreOptions = (list, index) => {
    const {
      showMoveOrCopyToList,
      moveOrCopyFolderDetails,
      folderListFetchInProgress,
      itemToMove,
      itemToCopy,
    } = this.props
    return showMoveOrCopyToList ? (
      <MoveOrCopy
        {...this.props}
        moveOrCopyFolderDetails={moveOrCopyFolderDetails}
        folderListFetchInProgress={folderListFetchInProgress}
        selectedOptionList={this.state.selectedOptionList}
        fetchSearchDataForMoveCopy={this.props.fetchSearchDataForMoveCopy}
        pasteFile={this.props.pasteFile}
        itemToMove={itemToMove}
        itemToCopy={itemToCopy}
      />
    ) : (
      this.renderMoreOptionsDefault(list, index)
    )
  }

  renderMoreOptionsDefault = (list, index) => {
    const { userPermission } = this.props
    let fileOptionType = ''
    if (list.sharedBy) {
      fileOptionType = 'shared'
    } else {
      fileOptionType = 'default'
    }
    const permission = calculateUserPermission(list, userPermission)
    return (
      <ul
        className="ppvx_overflow-menu__list list__options ppvx_overflow-menu__list--open"
        role="menu"
        id={`myOverflowMenu_${index}`}
      >
        {fileOptionsConstants.FileOptions[fileOptionType].map((fileItem) => {
          return list.fileType === fileItem.type
            ? this.checkOptions(fileItem, permission, fileOptionType, list).map(
                (options, indexs) => {
                  return (options === 'Delivery status' ||
                    options === 'Un Share') &&
                    !list.isShared
                    ? ''
                    : this.renderMoreMenu(indexs, list, options)
                },
              )
            : ''
        })}
      </ul>
    )
  }

  renderMoreMenu = (index, list, options) => {
    const { user } = this.props
    return user.accType === constants.AdhocUser &&
      options === 'File History' ? (
      ''
    ) : (
      <li className="list__options" key={index}>
        <a
          id={`${_.camelCase(options)}MenuItem`}
          className="ppvx_overflow-menu__list-item ppvx_text--md list__options"
          role="menuitem"
          tabIndex="-1"
          onClick={() => this.onOptionsClick(list, options)}
        >
          <Message
            id={`buttons.${
              getKeyByValue(
                fileOptionsConstants.LocalizeIdForMoreOptions,
                options,
              ).localizeId
            }`}
          />
        </a>
      </li>
    )
  }

  renderIcon = (list, progress) => {
    const { user } = this.props
    return list.fileType === 'folder' ? (
      this.renderFolderIcon(progress, list)
    ) : (
      <span
        className={`ppvx_icon ppvx_icon--size_lg list__file-type-icon 
          ${this.checkFileOrFolderPermission(list) ? '' : 'list__item-icon'} ${
          fileOptionsConstants.Icons[list.fileType]
        } ${progress ? 'list__item-list--onspin' : ''}`}
        data-pa-pgrp={`dropzone:${user.accType}`}
        data-pa-page={`dropzone:download:${list.fileType}:${user.accType}`}
        data-pa-click="download"
        onClick={() => this.onListItemClick(list)}
      />
    )
  }

  renderFolderIcon = (progress, list) => {
    const { user } = this.props
    return (
      <div
        className="list__item-folder-name flexCenter"
        data-pa-pgrp={`dropzone:${user.accType}`}
        data-pa-page={`dropzone:search:${list.fileType}:${user.accType}`}
        data-pa-click="search"
        onClick={() => this.onListItemClick(list)}
      >
        {!progress ? <FolderClose /> : <FolderCloseGrey />}
      </div>
    )
  }

  onDrag = (e, item, index) => {
    this.setState({ dragItem: index })
  }

  onDragStart = (event) => {
    event.dataTransfer.setData('text/plain', '')
    event.stopPropagation()
  }

  onDragOver = (event) => {
    event.stopPropagation()
    event.preventDefault()
  }

  onFileDrop = (event, list, index) => {
    const { dragItem } = this.state
    const { files, userPermission } = this.props
    event.stopPropagation()

    if (userPermission === shareConstants.FilePermissions.readWriteExecute) {
      if (dragItem >= 0) {
        if (dragItem !== index) {
          if (
            (files.results[dragItem].baseFolder === '/' &&
              files.results[dragItem].hasOwnProperty('sharedBy')) ||
            files.results[dragItem].isShared
          ) {
            event.preventDefault()
            return
          }
          if (files.results[index].fileType === 'folder') {
            let destination = `${files.results[index].path}/${files.results[dragItem].fileName}`

            this.props.moveOrRename(
              files.results[dragItem].path,
              destination,
              files.results[dragItem],
            )
          }
        }
      } else {
        event.preventDefault()
      }
    }
    return
  }

  onUploadFiles = (files) => {
    let fileArray = Array.from(files)
    this.props.onUploadFilesClick(fileArray)
  }

  setRenameValue = (event) => {
    this.setState({ renameValue: event.target.value })
  }

  captureRename = (event) => {
    const { renameValue } = this.state
    if (
      event.key === 'Enter' ||
      (typeof event.key === 'undefined' && renameValue.trim() !== '')
    ) {
      this.props.rename(renameValue)
    } else if (typeof event.key === 'undefined') {
      this.setState({
        renameValue: '',
      })
      this.props.rename('')
    }
  }

  onListItemClick = (list) => {
    const { hasFileToRename, fileToRename, userPermission } = this.props
    if (
      (hasFileToRename && fileToRename.path === list.path) ||
      (userPermission === 0 && list.fileType === 'file')
    ) {
      return
    }
    if (
      _.get(list, 'permission', '') === 'list' &&
      _.get(list, 'fileType', '') === 'file'
    ) {
      return
    }
    this.props.captureDoubleClick(list)
  }

  checkFileOrFolderPermission = (list) => {
    return (
      _.get(list, 'permission', '') === 'list' &&
      _.get(list, 'fileType', '') === 'file'
    )
  }

  renderFileName = (list, index, progress) => {
    const {
      fileToRename,
      hasFileToRename,
      renameIsInProgress,
      user,
    } = this.props
    const { renameValue, renderErrorFor, renderErrorType } = this.state
    const action = list.fileType === 'file' ? 'download' : 'search'

    return (
      <div className="ppvx_col-6 ppvx_col-lg-7 ppvx_col-md-6 list__name flexAlignCenter">
        {!renameIsInProgress &&
        hasFileToRename &&
        fileToRename &&
        fileToRename.path === list.path ? (
          <div className="ppvx_text-input ppvx_text-input--nolabel list_rename">
            <input
              className="ppvx_text-input__control"
              type="text"
              name={list.name}
              id="renameFile"
              placeholder={list.name}
              defaultValue={renameValue}
              autoFocus={true}
              onKeyPress={(evt) => this.captureRename(evt)}
              onChange={(evt) => this.setRenameValue(evt)}
              onBlur={(evt) => this.captureRename(evt)}
              maxLength={200}
            />
          </div>
        ) : (
          <div className="list__item-name">
            <a
              className={`ppvx_link ${
                this.checkFileOrFolderPermission(list)
                  ? 'list__item-name-label-listonly'
                  : 'list__item-name-label'
              } ${progress ? 'list__item-list--onspin' : ''}`}
              data-pa-pgrp={`dropzone:${user.accType}`}
              data-pa-page={`dropzone:${action}:${list.fileType}:${user.accType}`}
              data-pa-click={action}
              onClick={() => this.onListItemClick(list)}
            >
              {renameIsInProgress &&
              hasFileToRename &&
              fileToRename.path === list.path
                ? renameValue
                : checkEmailMaskBeforeRender(list, 'fileName')}
            </a>
            {list.status &&
              this.renderAlert(
                list,
                index,
                renderErrorFor,
                renderErrorType,
                '',
              )}
            {renameIsInProgress &&
              hasFileToRename &&
              fileToRename.path === list.path && (
                <div style={{ marginLeft: '10px' }}>
                  <p className="ppvx_loading-spinner" role="alert">
                    <span className="ppvx_loading-spinner__screenreader" />
                  </p>
                </div>
              )}
          </div>
        )}
      </div>
    )
  }

  onHoverItem = (index) => {
    const { multipleSelectItems, userPermission } = this.props
    this.setState({
      itemOnHover:
        multipleSelectItems.length > 0 ||
        userPermission ===
          shareConstants.FilePermissions[
            shareConstants.FilePermissionFromServer.list
          ]
          ? ''
          : index,
    })
  }

  checkRenderCheckBox = () => {
    const { user, baseFolder } = this.props
    if (user.accType === constants.AdhocUser && baseFolder === '/') {
      return false
    }
    return true
  }

  checkSpin = (itemToDelete, itemToDownload, list, itemToUnshare) => {
    const path = list.path
    return (
      (itemToDelete.length > 0 && itemToDelete.includes(path)) ||
      (itemToDownload.length > 0 && itemToDownload.includes(path)) ||
      (itemToUnshare.length > 0 && itemToUnshare.includes(path))
    )
  }

  checkCheckBoxSelection = (list) => {
    const { multipleSelectItems } = this.props
    return _.some(multipleSelectItems, list)
  }

  renderFilesAndFoldersList = (list, index) => {
    const {
      showButton,
      selectedItem,
      showOptions,
      itemToDelete,
      itemToDownload,
      multipleSelectItems,
      baseFolder,
      itemToUnshare,
    } = this.props
    const { itemOnHover } = this.state
    return (
      removeExtraSlashes(baseFolder) ===
        removeExtraSlashes(list.baseFolder) && (
        <li
          className={`list__item-list ${
            this.checkSpin(itemToDelete, itemToDownload, list, itemToUnshare)
              ? 'list__item-list--onspin'
              : ''
          }`}
          key={index}
          draggable="true"
          onDrag={(e) => this.onDrag(e, list, index)}
          onDragStart={(e) => this.onDragStart(e)}
          onDragOver={(e) => this.onDragOver(e)}
          onDrop={(e) => this.onFileDrop(e, list, index)}
          onMouseOver={() => this.onHoverItem(index)}
          onMouseLeave={() => this.onHoverItem('')}
          data-file-name={list.fileName}
          data-file-type={list.fileType}
        >
          <div className="list__item-box">
            <div className="list__item-content ppvx_text--md">
              {this.checkRenderCheckBox() && (
                <div className="list__checkbox flexCenter ppvx_checkbox ">
                  {itemOnHover === index || multipleSelectItems.length > 0 ? (
                    <div>
                      <input
                        className="list__checkbox-input ppvx_checkbox__input "
                        type="checkbox"
                        id={`checkbox_${index}`}
                        name="list_item"
                        checked={this.checkCheckBoxSelection(list)}
                        onChange={(e) => this.props.clickItems(e, list)}
                      />
                      <label
                        className="ppvx_checkbox__label"
                        htmlFor={`checkbox_${index}`}
                      />
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              )}
              <div className="ppvx_col-lg-1 list__type list__hide-mobile ">
                {this.renderIcon(
                  list,
                  this.checkSpin(
                    itemToDelete,
                    itemToDownload,
                    list,
                    itemToUnshare,
                  ),
                )}
              </div>
              {this.renderFileName(
                list,
                index,
                this.checkSpin(
                  itemToDelete,
                  itemToDownload,
                  list,
                  itemToUnshare,
                ),
              )}
              <div className="ppvx_col-4 ppvx_col-lg-2 list__date flexAlignCenter">
                {this.convertDate(list.modifiedDate)}
              </div>
              <div className="list__size list__hide-mobile ">
                {list.size ? formatFileSize(list.size) : '0 Bytes'}
              </div>
              <div className="list__more flexCenter">
                <div className="ppvx_overflow-menu">
                  <button
                    className={`ppvx_overflow-menu__btn list__options ${
                      this.checkSpin(
                        itemToDelete,
                        itemToDownload,
                        list,
                        itemToUnshare,
                      )
                        ? 'list__item-list--onspin'
                        : ''
                    }`}
                    data-overflow-menu={`myOverflowMenu_${index}`}
                    tabIndex="0"
                    aria-label="Overflow"
                    aria-haspopup="true"
                    aria-expanded="false"
                    onClick={() => this.props.fileOptionStatus(index, true)}
                  />
                  {showOptions &&
                    !showButton &&
                    index === selectedItem &&
                    this.renderMoreOptions(list, index)}
                </div>
              </div>
            </div>
          </div>
          {this.checkSpin(
            itemToDelete,
            itemToDownload,
            list,
            itemToUnshare,
          ) && (
            <div className="list__item-list--loader">
              <p className="ppvx_loading-spinner" role="alert">
                <span className="ppvx_loading-spinner__screenreader" />
              </p>
            </div>
          )}
        </li>
      )
    )
  }

  renderCreateNewFolder = () => {
    const { isCreateFolderInProgress, user } = this.props
    const { newFolderName } = this.state
    return (
      <li className="list__item-list" key="create_new_folder">
        <div className="list__item-box">
          <div className="list__item-content ppvx_text--md">
            {user.accType !== constants.AdhocUser && (
              <div className="list__checkbox flexCenter" />
            )}
            <div className="ppvx_col-lg-1 list__type list__hide-mobile ">
              <FolderClose />
            </div>
            <div className="ppvx_col-6 ppvx_col-lg-7  ppvx_col-md-6 list__name flexAlignCenter pointer">
              {!isCreateFolderInProgress ? (
                <div className="ppvx_text-input list__create-folder">
                  <InputBox
                    name="createFolder"
                    id="createFolder"
                    value={newFolderName}
                    label="labels.create.folder.placeholder"
                    isLabelHidden={false}
                    className="input-box"
                    labelClassName="list__create-folder--label"
                    placeholder=""
                    onChangeText={(e) => this.setNewFolderValue(e)}
                    onKeyPressText={(e) => this.capture(e)}
                    onBlurText={(e) => this.capture(e)}
                    maxLength={200}
                    autoFocus={true}
                    style={{
                      padding: '20px 10px 5px 10px',
                      borderRadius: '4px',
                      border: '#0070ba 2px solid',
                    }}
                  />
                  {/* <input
                    className="ppvx_text-input__control"
                    type="text"
                    name="createFolder"
                    id="createFolder"
                    placeholder=" "
                    autoFocus={true}
                    value={newFolderName}
                    onKeyPress={(ent) => this.capture(ent)}
                    onChange={(evt) => this.setNewFolderValue(evt)}
                    onBlur={(evt) => this.capture(evt)}
                    maxLength={200}
                  />
                  <label
                    htmlFor="createFolder"
                    className="ppvx_text-input__label"
                  >
                    Enter Folder name
                  </label> */}
                </div>
              ) : (
                <div className="ppvx_text-input list__create-folder list__create-folder-progress">
                  <div>{newFolderName}</div>
                  <div style={{ marginLeft: '10px' }}>
                    <p className="ppvx_loading-spinner" role="alert">
                      <span className="ppvx_loading-spinner__screenreader" />
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </li>
    )
  }

  renderDummyList = () => {
    const placeHolderGrids = []
    placeHolderGrids.push(<li key="dummyList" />)
    for (let index = 0; index <= 4; index++) {
      placeHolderGrids.push(
        <li className="list__item-list" key={index}>
          <div className="list__item-box--dummy">
            <div className="ppvx_col-6 ppvx_col-lg-7  ppvx_col-md-6 list__name flexAlignCenter list__dummy-list" />
            <div className="ppvx_col-4 ppvx_col-lg-2 list__date flexAlignCenter list__dummy-list" />
            <div className="list__size list__hide-mobile list__dummy-list" />
          </div>
        </li>,
      )
    }

    return (
      <div className="container-dummy_list">
        <ul className="list__item-container">{placeHolderGrids}</ul>
      </div>
    )
  }

  renderSortIcon = (sortBy) => {
    return (
      <span
        className={`ppvx_icon ppvx_icon--size_xs list__sort-icon ${this.sortIcon(
          sortBy,
        )}`}
      />
    )
  }

  sortIcon = (sortby) => {
    const { sortBy, sortType } = this.props
    return (
      sortBy === sortby &&
      `${fileOptionsConstants.Icons[sortType]} ${
        sortType === 'asc' ? '' : 'list__sort-icon--desc'
      }`
    )
  }

  getSortOptions = (by) => {
    const { sortType, sortBy } = this.props
    if (sortBy === by) {
      return sortType === 'asc' ? 'desc' : 'asc'
    }
    return 'desc'
  }

  renderListHeader = () => {
    const { sortBy, multipleSelectItems, files, user } = this.props
    const { itemOnHover } = this.state

    return (
      <li className="list__item-list" key="header">
        <div className="list__item-box">
          <div className="list__item-content ppvx_text--md">
            <div
              className="list__checkbox flexCenter ppvx_checkbox "
              onMouseOver={() => this.onHoverItem('all')}
              onMouseLeave={() => this.onHoverItem('')}
            >
              {itemOnHover === 'all' || multipleSelectItems.length > 0 ? (
                <div>
                  <input
                    className="list__checkbox-input ppvx_checkbox__input "
                    type="checkbox"
                    id="checkbox_selectall"
                    name="list_item"
                    checked={
                      multipleSelectItems.length ===
                      _.get(files, 'results', []).length
                    }
                    onChange={(e) => this.props.clickItems(e, '', true)}
                  />
                  <label
                    className="ppvx_checkbox__label"
                    htmlFor="checkbox_selectall"
                  />
                </div>
              ) : (
                ''
              )}
            </div>
            <div
              className="ppvx_col-lg-1 list__type list__hide-mobile list__header"
              data-pa-pgrp={`dropzone:${user.accType}`}
              data-pa-page={`dropzone:search:sort:${this.getSortOptions(
                'fileType',
              )}:fileType:${user.accType}`}
              data-pa-click="sort_fileType"
              onClick={() =>
                this.onSortIconClick(
                  this.getSortOptions('fileType'),
                  'fileType',
                )
              }
            >
              <Message id="labels.listTable.type" />{' '}
              {sortBy === 'fileType' && this.renderSortIcon('fileType')}
            </div>
            <div
              className="ppvx_col-6 ppvx_col-lg-7  ppvx_col-md-6 list__name flexAlignCenter pointer list__header"
              data-pa-pgrp={`dropzone:${user.accType}`}
              data-pa-page={`dropzone:search:sort:${this.getSortOptions(
                'fileName',
              )}:fileName:${user.accType}`}
              data-pa-click="sort_fileName"
              onClick={() =>
                this.onSortIconClick(
                  this.getSortOptions('fileName'),
                  'fileName',
                )
              }
            >
              <Message id="labels.listTable.name" />{' '}
              {sortBy === 'fileName' && this.renderSortIcon('fileName')}
            </div>
            <div
              className="ppvx_col-4 ppvx_col-lg-2 list__date flexAlignCenter list__header"
              data-pa-pgrp={`dropzone:${user.accType}`}
              data-pa-page={`dropzone:search:sort:${this.getSortOptions(
                'modifiedDate',
              )}:modifiedDate:${user.accType}`}
              data-pa-click="sort_modifiedDate"
              onClick={() =>
                this.onSortIconClick(
                  this.getSortOptions('modifiedDate'),
                  'modifiedDate',
                )
              }
            >
              <Message id="labels.listTable.modifiedDate" />{' '}
              {sortBy === 'modifiedDate' && this.renderSortIcon('modifiedDate')}
            </div>
            <div
              className="list__size list__hide-mobile list__header "
              data-pa-pgrp={`dropzone:${user.accType}`}
              data-pa-page={`dropzone:search:sort:${this.getSortOptions(
                'size',
              )}:size:${user.accType}`}
              data-pa-click="sort_size"
              onClick={() =>
                this.onSortIconClick(this.getSortOptions('size'), 'size')
              }
            >
              <Message id="labels.listTable.size" />{' '}
              {sortBy === 'size' && this.renderSortIcon('size')}
            </div>
            <div className="list__more flexCenter list__header list__header-more">
              <Message id="labels.listTable.more" />
            </div>
          </div>
        </div>
      </li>
    )
  }

  renderFilesToUpload = (list, index) => {
    const { baseFolder, user } = this.props
    const { renderErrorFor, renderErrorType } = this.state
    const today = new Date()
    const date = `${today.getFullYear()}-${
      today.getMonth() + 1
    }-${today.getDate()} ${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`
    const progress = isNaN(list.progress) ? 100 : list.progress.toFixed(2)
    return (
      removeExtraSlashes(baseFolder) === removeExtraSlashes(list.basePath) && (
        <li
          className="list__item-list"
          key={`${list.name}_${index}`}
          draggable="true"
        >
          <div className="list__item-box">
            <div className="list__item-content ppvx_text--md">
              {user.accType !== constants.AdhocUser && (
                <div className="list__checkbox flexCenter" />
              )}
              <div className="ppvx_col-lg-1 list__type list__hide-mobile ">
                {list.type === 'folder' ? (
                  <FolderClose />
                ) : (
                  <span
                    className={`ppvx_icon ppvx_icon--size_lg list__file-type-icon ${fileOptionsConstants.Icons.file} `}
                  />
                )}
              </div>
              <div className="ppvx_col-6 ppvx_col-lg-7  ppvx_col-md-6 list__name flexSpaceBetween">
                <div>{list.name}</div>
                {list.status &&
                  this.renderAlert(
                    list,
                    index,
                    renderErrorFor,
                    renderErrorType,
                    'upload',
                  )}
              </div>
              <div className="ppvx_col-4 ppvx_col-lg-2 list__date flexAlignCenter">
                {this.convertDate(date)}
              </div>
              <div className="list__size list__hide-mobile ">
                {list.size ? formatFileSize(list.size) : '0 Bytes'}
              </div>
              <div className="list__more flexCenter" />
            </div>
          </div>
          {list.status === 'uploading' && (
            <div className="list__upload-container">
              <div
                className={`flexAlignCenter list__upload list__upload--head ${
                  progress === 100 ? 'list__upload--animated' : ''
                }`}
                style={{ width: `${progress}%` }}
              />
              <div
                className={`flexAlignCenter list__upload list__upload--tail ${
                  progress === 100 ? 'list__upload--animated' : ''
                }`}
                style={{ width: `${100 - progress}%` }}
              />
            </div>
          )}
        </li>
      )
    )
  }

  renderError = (type, index, renderErrorFor, renderErrorType) => {
    this.prevRenderErrorFor = [renderErrorFor, renderErrorType]
    this.setState({ renderErrorFor: index, renderErrorType: type })
  }

  renderAlert = (list, index, renderErrorFor, renderErrorType, type) => {
    return (
      <div
        className={`${
          type === '' ? `alert_${index}` : `upload_alert_${index}`
        } alert__icon alert__${list.status}`}
      >
        {list.status === 'failure' && (
          <div
            className={`${
              type === '' ? `alert_${index}` : `upload_alert_${index}`
            }  alert__icon-error`}
            onClick={() =>
              this.renderError(type, index, renderErrorFor, renderErrorType)
            }
          />
        )}
        {list.status === 'success' && (
          <div
            className={`${
              type === '' ? `alert_${index}` : `upload_alert_${index}`
            }  alert__icon-success`}
          />
        )}
        {renderErrorFor === index &&
          renderErrorType === type &&
          list.msg !== '' &&
          list.status !== 'success' && (
            <div
              className={`${
                type === '' ? `alert_${index}` : `upload_alert_${index}`
              }  alert__tooltip-${list.status}`}
            >
              {list.msg}
            </div>
          )}
      </div>
    )
  }

  renderActualList = () => {
    const {
      files,
      showCreateFolder,
      filesToUpload,
      limit,
      pageNo,
      user,
      baseFolder,
      userPermission,
    } = this.props

    let list = []
    if (filesToUpload.length > 0) {
      filesToUpload.map((item, index) => {
        list.push(this.renderFilesToUpload(item, index))
      })
    }
    if (files.results && files.results.length > 0) {
      const min = pageNo > 1 ? (pageNo - 1) * limit : 0
      const max = pageNo * limit
      const filesToRender = files.results.slice(min, max)
      filesToRender.map((item, index) => {
        list.push(this.renderFilesAndFoldersList(item, index))
      })
    }
    if (
      !showCreateFolder &&
      this.isFolderContainsFileToUpload(filesToUpload) === 0 &&
      files.results &&
      files.results.length === 0
    ) {
      list.push(
        <div className="no-data__msg" key="no_data-msg">
          <div className="ppvx__text--md">
            <Message id="message.list.noFiles" />
          </div>
          <div className="no-data__msg--sub">
            {checkNoDataMessageVisibility(
              user,
              baseFolder,
              userPermission,
              'upload',
            ) && (
              <div>
                <Message id="message.list.drag" />{' '}
                {checkNoDataMessageVisibility(
                  user,
                  baseFolder,
                  userPermission,
                  'createFolder',
                )
                  ? getLocalizedContent('message.list.create.folder')
                  : ''}{' '}
              </div>
            )}
          </div>
        </div>,
      )
    }

    return list
  }
  isFolderContainsFileToUpload = (filesToUpload) => {
    const { baseFolder } = this.props
    return filesToUpload.filter((file) => {
      return (
        removeExtraSlashes(file.basePath) === removeExtraSlashes(baseFolder)
      )
    }).length
  }

  renderListView = () => {
    const {
      showCreateFolder,
      isFilesFetchInProgress,
      files,
      filesToUpload,
    } = this.props
    return (
      <Dropzone onDrop={(acceptedFiles) => this.onUploadFiles(acceptedFiles)}>
        {({ getRootProps }) => (
          <ul {...getRootProps()} className="list__item-container">
            {isFilesFetchInProgress || showCreateFolder
              ? this.renderListHeader()
              : (filesToUpload.length > 0 ||
                  (files.results && files.results.length > 0)) &&
                this.renderListHeader()}
            {showCreateFolder && this.renderCreateNewFolder()}
            {isFilesFetchInProgress
              ? this.renderDummyList()
              : this.renderActualList()}
          </ul>
        )}
      </Dropzone>
    )
  }

  render() {
    return (
      <div className="grid__view-conatiner">
        <div
          className="list__view-conatiner"
          id="listView"
          data-testid="list-view"
        >
          <div className="list__item-content-holder ">
            {this.renderListView()}
          </div>
        </div>
      </div>
    )
  }
}
export default ListView
